/* Built In Imports */
import { usePathname } from 'next/navigation';
/* External Imports */
import { Box, Grid, Image, Text, Flex } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import { ProgramStructureSt } from '@ieo/Common/CompLangConfig';
import { usePageConfigValue } from '@ieo/hooks/usePageConfigVal';
import { createSectionContentMap } from '../../components/Utility/Shared/SharedService';
import ProgramStructureCardV3 from './ProgramStructureCardV3';

/* Configs */
/* Styles */
/* Services */
/* Styles */

/**
 *
 * @param {Object} SectionContent
 * @param {String} region
 * @param {String} lang
 * @returns {ReactElement} ProgramStructure
 */

const ProgramStructureV3 = ({
  sectionContent,
  region,
  lang,
  pageName,
  pageData,
  prgData,
  isInPerson = false,
}) => {
  const path = usePathname();
  const currentCoupon = Object.values(prgData)[0]?.coupon;

  const { pageConfigVal, isThemeActive } = usePageConfigValue(
    pageData,
    region,
    currentCoupon
  );
  const sectionContentMap = createSectionContentMap(sectionContent);
  const duration = sectionContent.find(el => el.fieldId === 'ie-duration-2');

  const defaultData = [
    {
      id: 1,
      title: 'Steps 1 - 6',
      duration: '11.5 Hours',
      schedule: 'Do at your own space',
      scheduleIcon: sectionContentMap['own-space-icon']?.image?.url,
      isWeekend: false,
    },
    {
      id: 2,
      title: 'Step 7',
      duration: '14 Hours',
      schedule: 'Weekend of your choice',
      scheduleIcon: sectionContentMap['own-space-icon']?.image?.url,
      onlineInstructions: [
        'Saturday - 4.5 Hours',
        'Sunday - 9 Hours | All Day',
      ],

      isWeekend: true,
    },
  ];

  const defaultDataInPerson = [
    {
      id: 1,
      title: sectionContentMap['inperson-card-1']?.text,
      duration: sectionContentMap['evening-text']?.text,
      isWeekend: false,
    },
    {
      id: 2,
      title: sectionContentMap['inperson-card-2']?.text,
      duration: sectionContentMap['all-day-text']?.text,
      schedule: sectionContentMap['veg-lunch-text']?.text,
      scheduleIcon: sectionContentMap['veg-icon']?.image?.url,
      isWeekend: true,
    },
    {
      id: 3,
      title: sectionContentMap['inperson-card-3']?.text,
      duration: sectionContentMap['all-day-text-2']?.text,
      schedule: sectionContentMap['veg-lunch-text-2']?.text,
      scheduleIcon: sectionContentMap['veg-icon']?.image?.url,
      isWeekend: true,
    },
  ];
  const dataToRender = isInPerson ? defaultDataInPerson : defaultData;
  const url = path.includes('offer/under-25s');
  return (
    <Box
      bg="#fff"
      // mx={{ base: 4, md: 0 }}
      // background={
      //   url
      //     ? 'url(https://static.sadhguru.org/d/46272/1710743888-1710584276-pbg1.jpg) repeat'
      //     : {
      //         base:
      //           isThemeActive && pageConfigVal
      //             ? `url(${pageConfigVal?.prgStructure?.bgImage?.mob}) repeat-x #F1EBDF`
      //             : `#F1EBDF`,
      //         sm:
      //           isThemeActive && pageConfigVal
      //             ? `url(${pageConfigVal?.prgStructure?.bgImage?.tab}) repeat-x #F1EBDF`
      //             : `#F1EBDF`,
      //         md:
      //           isThemeActive && pageConfigVal
      //             ? `url(${pageConfigVal?.prgStructure?.bgImage?.desktop}) repeat-x #F1EBDF`
      //             : `#F1EBDF`,
      //         lg:
      //           isThemeActive && pageConfigVal
      //             ? `url(${pageConfigVal?.prgStructure?.bgImage?.bigScreen}) repeat-x #F1EBDF`
      //             : `#F1EBDF`,
      //       }
      // }
      // bgRepeat="repeat-x"
      bgRepeat={url && 'repeat'}
      bgPos={{ base: 'inherit', md: 'top' }}
      // bgSize={{ base: 'auto 50px', md: 'auto 10%', xl: 'auto 15%' }}
    >
      <Flex
        // maxW={1030}
        // bg="#F1EBDF"
        pt={{ base: 14, md: 20 }}
        // pb={{ base: '16px', md: '41px' }}
        // margin={'0 auto'}
      >
        <Box w="full">
          <Flex
            alignItems={{ sm: 'center' }}
            flexDir={{ base: 'column', sm: 'row' }}
            justify="space-between"
            px={{ base: '1rem', xl: '0px' }}
          >
            <Box
              // w="full"
              as="h2"
              mx={'auto'}
              // lineHeight={{ base: '42px', lg: 'initial' }}
              // pb={{ base: '18px', md: '26px' }}
              {...ProgramStructureSt[lang]?.h2InPerson}
              // w={{ base: '300px', md: '620px', xl: '880px' }}
              textAlign="center"
            >
              {sectionContentMap['ieo-steps-seven']?.text}
            </Box>
          </Flex>
          <Box mt="34px">
            <Text
              as="h4"
              textAlign={{
                base: 'center',
                md:
                  path.indexOf('inner-engineering-v2') > -1
                    ? 'right'
                    : 'center',
              }}
              mb={'5px'}
              {...ProgramStructureSt[lang]?.h4}
            >
              {sectionContentMap['ieo-program-structure-steps']?.text}
            </Text>

            <Text
              as="h4"
              textAlign="center"
              fontFamily={'FedraSansStd-Book'}
              {...ProgramStructureSt[lang]?.h4}
              color="#A67411"
              pt="2px"
              pb="20px"
              display="flex"
              alignItems="center"
              gap="10px"
              justifyContent="center"
              fontSize={{ base: '18px', md: '20px' }}
            >
              <Image
                w={{ base: '20px', md: '24px' }}
                src={sectionContentMap['clock-icon-gold']?.image?.url}
                alt=""
              />
              {
                sectionContentMap[
                  isInPerson ? 'ie-duration-1' : 'ie-duration-2'
                ]?.text
              }
            </Text>

            <Flex px={{ base: 6 }} mt={8} gap={9} justify="center" wrap="wrap">
              {dataToRender?.map((item, index) => (
                <Box
                  key={item.id}
                  position="relative"
                  bg="#F1EBDF"
                  w={{ base: '100%', md: '295px' }}
                  py={{ base: 4 }}
                  minH="max-content"
                >
                  {/* Orange Header */}
                  <Box
                    width="65%"
                    position="absolute"
                    top={-4}
                    left="50%"
                    transform="translateX(-50%)"
                    bg="#CE6113"
                    color="white"
                    px={6}
                    py={3}
                    textAlign="center"
                    fontWeight="500"
                    fontSize={'16px'}
                    fontFamily={'FedraSansStd-medium'}
                    lineHeight={'120%'}
                  >
                    {item.title}
                  </Box>

                  {/* Content */}
                  <Flex
                    direction="column"
                    align="center"
                    justify="center"
                    mt={8}
                  >
                    <Flex align="center" mb={1}>
                      <Image
                        src={sectionContentMap['clock-icon']?.image?.url}
                        alt=""
                        mr={2}
                      />
                      <Text fontSize={'16px'} fontFamily={'FedraSansStd-Book'}>
                        {item.duration}
                      </Text>
                    </Flex>

                    <Flex align="center" mb={item.isWeekend ? 1 : 0}>
                      {typeof item.scheduleIcon === 'string' ? (
                        <Image src={item.scheduleIcon} alt="" mr={2} />
                      ) : (
                        <Box mr={2}>{item.scheduleIcon}</Box>
                      )}
                      <Text fontSize={'16px'} fontFamily={'FedraSansStd-Book'}>
                        {item.schedule}
                      </Text>
                    </Flex>

                    {item.onlineInstructions && (
                      <Text
                        mt={1}
                        ml={5}
                        fontSize={'14px'}
                        textAlign="left"
                        fontFamily={'FedraSansStd-Book'}
                      >
                        {item.onlineInstructions.map((detail, idx) => (
                          <span key={idx}>
                            {detail}
                            {idx < item.onlineInstructions.length - 1 && <br />}
                          </span>
                        ))}
                      </Text>
                    )}
                  </Flex>
                </Box>
              ))}
            </Flex>

            <Text
              pt={{ base: 4, md: 8 }}
              pb={{ base: 1, md: 4 }}
              as="h3"
              textAlign={{
                base: 'center',
                md:
                  path.indexOf('inner-engineering-v2') > -1
                    ? 'right'
                    : 'center',
              }}
              {...ProgramStructureSt[lang]?.h3InPerson}
            >
              {sectionContentMap['ieo-program-days1-6-text']?.text}
            </Text>

            <Grid
              templateColumns={{
                base: '1fr 1fr',
                sm: 'repeat(2, 1fr)',
                lg: 'repeat(4, 1fr)',
              }}
              px={{ base: 4, sm: 3, md: 12, lg: 10 }}
              // gap={{ base: '2px', sm: '20px', md: '40px', lg: '40px' }}
              rowGap={{ base: '2px', sm: '20px', md: '30px', lg: '40%' }}
              columnGap={{ base: 2, sm: 2, md: '0px', lg: '20px' }}
              mt={{ base: '0', md: '14.4px' }}
              borderRadius={'7px'}
            >
              {sectionContentMap['custom-card-group']?.cards?.map(card => (
                <ProgramStructureCardV3
                  key={nanoid(4)}
                  lang={lang}
                  data={card}
                />
              ))}
            </Grid>
          </Box>
        </Box>
      </Flex>
    </Box>
  );
};

export default ProgramStructureV3;
